import { render } from "./HeroiconsOutlineBeaker.vue?vue&type=template&id=40410525"
const script = {}

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineBeaker.vue"]])

export default __exports__